import { ACTIONS, SUBTOPIC_ALL, TOPIC_ALL } from '../../constants';

const initState = {
  category: '',
  topic: '',
  subtopic: '',
  sorting: 0, // 0,1 - name, 2,3 - date
  data: [],
  visibleData: [],
};

const dataCategory = (state = initState, action) => {
  switch (action.type) {
    case ACTIONS.CHANGE_CATEGORY:
      return {
        ...state,
        category: action.categoryId,
        topic: TOPIC_ALL,
        subtopic: SUBTOPIC_ALL,
        data: action.data,
        visibleData: action.data,
      };
    case ACTIONS.CHANGE_TOPIC:
      return {
        ...state,
        topic: action.topic,
        subtopic: SUBTOPIC_ALL,
        visibleData: state.data.filter(item =>
          action.topic === TOPIC_ALL ||
            item[1].topic.indexOf(action.topic) !== -1),
      };
    case ACTIONS.CHANGE_SUBTOPIC:
      return {
        ...state,
        subtopic: action.subtopic,
      };
    case ACTIONS.CHANGE_SORTING:
      return {
        ...state,
        sorting: action.sorting,
      };
    default:
      return state;
  }
};

export default dataCategory;



// WEBPACK FOOTER //
// ./src/redux/reducers/dataCategory.js